// @flow
import RefreshToken from './RefreshToken';

type Session = {
  refreshToken: RefreshToken;
  callSign: ?string;
}

export { RefreshToken };
export type { Session };



// WEBPACK FOOTER //
// ./src/statsradio/modules/authentication/session/domain/Session.js